import React, { useState, useEffect } from 'react';
import './index.scss';

export const CustomInput = ({ name, label, getInput, empty, inputValue, placeholder, type = 'text', errorMsgBag = null }) => {
  const [ fill, setFill ] = useState(false);
  return (
    <div className={`custom-input ${fill ? '-fill' : ''} ${empty ? '-empty' : ''}`}
      onClick={() => !fill && setFill(!fill)}
    >
      <div className={`label ${(errorMsgBag && errorMsgBag[name]) ? '-error' : ''}`} >
        { label }
        { (errorMsgBag && errorMsgBag[name]) && <span className="error">{ errorMsgBag[name] }</span> }
      </div>
      <input value={inputValue} type={type} name={name}
        placeholder={placeholder ? placeholder : ''}
        onFocus={() => !fill && setFill(!fill)}
        onChange={e => getInput(e.currentTarget.value, name)}
        onBlur={e => getInput(e.currentTarget.value, name)} />
    </div>
  )
}

export const CustomSelect = ({ name, children, getInput, inputValue, label, errorMsgBag = null }) => {
  return (
    <div className={`custom-select`}>
      {
        label &&
        <div className={`label ${ inputValue ? '-fill' : '' }`} >
          { label }
          { (label && errorMsgBag && errorMsgBag[name]) && <span className="error">{ errorMsgBag[name] }</span> }
        </div>
      }
      <select value={ inputValue } onChange={e => getInput(e.currentTarget.value)} name={name}>
        { label && <option value=""></option> }
        { children }
      </select>
      <i className="icon-down"></i>
    </div>
  )
}

export const CustomDropdown = ({ className, name, label, category = 'category', data, getInput, inputValue, errorMsgBag }) => {
  const [ open, setOpen ] = useState(false);
  const [ select, setSelect] = useState(null);
  return (
    <React.Fragment>
      { open && <div className="custom-dropdown-cover" onClick={() => setOpen(false)}></div>}
      <div className={`custom-dropdown ${className ? className : ''} ${open ? 'open' : ''}`}>
        {
          label &&
          <div className={`label ${ inputValue ? '-fill' : '' } ${(errorMsgBag && errorMsgBag[name]) ? '-error' : ''}`} >
            { label }
            { (label && errorMsgBag && errorMsgBag[name]) && <span className="error">{ errorMsgBag[name] }</span> }

          </div>
        }
        <div className="dropdown-content" onClick={ () => setOpen(!open) }>
          <span>{ data && data.find(item => item === select) ? data.find(item => item === select) : category }</span>
          <div className="icon">
            <i className={`icon-up   ${open ? 'active' : ''}`}></i>
            <i className={`icon-down ${open ? 'active' : ''}`}></i>
          </div>
        </div>
        <div className={`dropdown-list ${open ? 'active' : ''}`}>
          <div className="dropdown-item" onClick={ () => setOpen(false) }>
            <span>{ category }</span>
          </div>
          {
            data && data.map((item, i) => (
              <div className="dropdown-item" key={i} onClick={() => {
                getInput(item);
                setSelect(item);
                setOpen(false);
              }}>
                <span>{ item }</span>
              </div>
            ))
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export const CustomTextarea = ({ name, label, getInput, empty, inputValue }) => {
  const [ fill, setFill ] = useState(false);
  return (
    <div className={`custom-textarea ${fill ? '-fill' : ''} ${empty ? '-empty' : ''}`}
      onClick={() => !fill && setFill(!fill)}
    >
      <div className="label">{label}</div>
      <textarea name={name} value={ inputValue } onChange={e => getInput(e.currentTarget.value)} onBlur={e => getInput(e.currentTarget.value)}></textarea>
    </div>
  )
}

export const CustomCheckbox = ({ name, label, getInput }) => (
  <div className="custom-checkbox">
    <input name={name} id={ label } type="checkbox" onChange={e => getInput(e.currentTarget.checked)}/>
    <label htmlFor={ label }></label>
  </div>
)


export const CustomRadio = ({ name, label, options, getInput }) => {
  const [current, setCurrent] = useState(0);

  // set default value
  useEffect(() => {
    getInput(options[0], name);
  }, []);

  return (
    <div className="custom-radio">
      {
        options && options.map((item, i) =>
          <button key={i} className={`radio ${ current === i ? '-active' : '' }`}
          onClick={e => {
            setCurrent(i);
            getInput(options[i], name);
          } }>
            <span>{item}</span>
          </button>
        )
      }
    </div>
  )
}